import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_TICKET_STATUS, GET_TICKET_STATUS_SUCCESS, GET_TICKET_STATUS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getTicketStatus({ payload }) {
  const { cardName } = payload.urlParams;
  const { urlParams = {} } = payload;
  const { name, ...restParams } = urlParams;

  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/card-states/${name ?? ''}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...restParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_TICKET_STATUS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_TICKET_STATUS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_TICKET_STATUS_ERROR, payload: error });
  }
}

export function* watchGetTicketStatus() {
  yield takeEvery(GET_TICKET_STATUS, getTicketStatus);
}

function* getTicketStatusSaga() {
  yield all([fork(watchGetTicketStatus)]);
}

export default getTicketStatusSaga;
